
export default new class PreloaderOverlay {
    constructor() {
        this.$preloader = $('.js-preloaderOverlay');
        this.delay = 350;
    }

    show () {
        this.$preloader.fadeIn(this.delay);
        setTimeout(() => {
            this.$preloader.removeClass('_hidden');
        }, this.delay);
    }

    hide () {
        this.$preloader.fadeOut(this.delay);
        setTimeout(() => {
            this.$preloader.addClass('_hidden');
        }, this.delay);
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/preloader-overlay/preloader-overlay.js